module.exports = __webpack_public_path__ + "img/login-banner.5473326f.png";